import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/research-bar/embed')({
  beforeLoad: () => {
    throw redirect({ replace: true, to: '/recherche/integration' })
  },
})
